import script from "./HrTr.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTr.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
